const TermsOfServiceFooter = () => {
    return <div style={{textAlign: "center"}}>
        <p>
            <a href="https://www.realeyesit.com/terms-of-service/" target="_blank">Terms of Service</a> and <a href="https://www.realeyesit.com/privacy-policy/" target="_blank">Privacy Policy.</a>
        </p>
    </div>
}

export default TermsOfServiceFooter;